const TOKEN_PATTERN = /^[A-Za-z0-9_-]{4,80}$/;

export function readDrillToken(search: string): string {
  const raw = new URLSearchParams(search).get('u') || '';
  return TOKEN_PATTERN.test(raw) ? raw : '';
}

export function readResultsKey(search: string): string {
  return (new URLSearchParams(search).get('k') || '').trim();
}

export type DrillEventName = 'view' | 'open' | 'click';

export function drillEventPayload(
  event: DrillEventName,
  token: string,
  extras: { path?: string; referrer?: string } = {}
): string {
  return JSON.stringify({
    event,
    token: token || 'unknown',
    path: extras.path || '',
    referrer: extras.referrer || '',
    drill: 'drill-1',
  });
}

export function recordDrillView(token: string): void {
  if (typeof window === 'undefined') return;

  const payload = drillEventPayload('view', token, {
    path: window.location.pathname,
    referrer: document.referrer || '',
  });

  try {
    const blob = new Blob([payload], { type: 'application/json' });
    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon('/api/drill-event', blob)) {
      return;
    }
  } catch {
    // Fall through to fetch.
  }

  fetch('/api/drill-event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => {
    // Tracking must never break the debrief page.
  });
}
